export const metricsRequestTypes = {
  pageviews: 'pageviews',
  visitors: 'visitors',
};
